export const LIST_REGISTATION = 'LIST_REGISTATION';
export const CREATE_REGISTATION = 'CREATE_REGISTATION';
export const SHOW_REGISTATION = 'SHOW_REGISTATION';
export const UPDATE_REGISTATION = 'UPDATE_REGISTATION';
export const DELETE_REGISTATION = 'DELETE_REGISTATION';
export const ADD_DELETE = 'ADD_DELETE';
export const CHECK_ALL = 'CHECK_ALL';
